import { ArticleType } from './article-type.enum';
import { ArticleStatus } from './article-status.enum';
import { randomTitle, RandomGenerator } from '../../../test-utils';
var ArticleBuilder = /** @class */ (function () {
    function ArticleBuilder() {
        this.article = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            title: 'My Test Article',
            categoryId: '',
            content: 'bob',
            creationDate: Date.now() - 3600000,
            lastUpdateDate: Date.now(),
            contentLastUpdateDate: Date.now(),
            type: ArticleType.ARTICLE,
            locale: 'en',
            primaryLocale: 'en',
            status: ArticleStatus.PUBLISHED,
            authorId: '2f33c44c-9d1c-410c-9763-fd8d1b349501',
            relatedTicketsCount: 0,
            position: 1,
            url: '/some-url',
            uri: '/article/some-url',
            labels: [],
            excludedFromHelpCenterContentScope: false,
            author: {
                id: '2f33c44c-9d1c-410c-9763-fd8d1b349501',
                firstName: 'Bob'
            },
            summary: 'some summary',
            relatedQuestions: ['some question1', 'some question2']
        };
    }
    ArticleBuilder.prototype.withId = function (id) {
        this.article.id = id;
        return this;
    };
    ArticleBuilder.prototype.withTitle = function (title) {
        this.article.title = title;
        return this;
    };
    ArticleBuilder.prototype.withContent = function (content) {
        this.article.content = content;
        return this;
    };
    ArticleBuilder.prototype.withCreationDate = function (creationDate) {
        this.article.creationDate = creationDate;
        return this;
    };
    ArticleBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.article.lastUpdateDate = lastUpdateDate;
        return this;
    };
    ArticleBuilder.prototype.withCategoryId = function (categoryId) {
        this.article.categoryId = categoryId;
        return this;
    };
    ArticleBuilder.prototype.withType = function (type) {
        this.article.type = type;
        return this;
    };
    ArticleBuilder.prototype.withLocale = function (locale) {
        this.article.locale = locale;
        return this;
    };
    ArticleBuilder.prototype.withPrimaryLocale = function (primaryLocale) {
        this.article.primaryLocale = primaryLocale;
        return this;
    };
    ArticleBuilder.prototype.withStatus = function (status) {
        this.article.status = status;
        return this;
    };
    ArticleBuilder.prototype.withAuthorId = function (authorId) {
        this.article.authorId = authorId;
        return this;
    };
    ArticleBuilder.prototype.withRelatedTicketCount = function (linkedTicketsCount) {
        this.article.relatedTicketsCount = linkedTicketsCount;
        return this;
    };
    ArticleBuilder.prototype.withPosition = function (position) {
        this.article.position = position;
        return this;
    };
    ArticleBuilder.prototype.withResolution = function (resolution) {
        this.article.resolution = resolution;
        return this;
    };
    ArticleBuilder.prototype.withResolutionEta = function (resolutionEta) {
        this.article.resolutionEta = resolutionEta;
        return this;
    };
    ArticleBuilder.prototype.withVotes = function (votes) {
        this.article.votes = votes;
        return this;
    };
    ArticleBuilder.prototype.withHandledByUserIds = function (handledByUserIds) {
        this.article.handledByUserIds = handledByUserIds;
        return this;
    };
    ArticleBuilder.prototype.withCollaboratorIds = function (collaboratorIds) {
        this.article.collaboratorIds = collaboratorIds;
        return this;
    };
    ArticleBuilder.prototype.withTranslations = function (translations) {
        this.article.translations = translations;
        return this;
    };
    ArticleBuilder.prototype.withUrl = function (url) {
        this.article.url = url;
        return this;
    };
    ArticleBuilder.prototype.withUri = function (uri) {
        this.article.uri = uri;
        return this;
    };
    ArticleBuilder.prototype.withAuthor = function (author) {
        this.article.author = author;
        return this;
    };
    ArticleBuilder.prototype.withAbTestInfo = function (abTestInfo) {
        this.article.abTestInfo = abTestInfo;
        return this;
    };
    ArticleBuilder.prototype.build = function () {
        return this.article;
    };
    ArticleBuilder.prototype.withLabels = function (labels) {
        this.article.labels = labels;
        return this;
    };
    ArticleBuilder.prototype.withSummary = function (summary) {
        this.article.summary = summary;
        return this;
    };
    ArticleBuilder.prototype.withRelatedQuestions = function (relatedQuestions) {
        this.article.relatedQuestions = relatedQuestions;
        return this;
    };
    ArticleBuilder.generateRandomList = function (num) {
        return randomTitle(num)
            .map(function (title) { return new ArticleBuilder()
            .withTitle(title)
            .withId(RandomGenerator.randomId())
            .build(); });
    };
    return ArticleBuilder;
}());
export { ArticleBuilder };
//# sourceMappingURL=article.builder.js.map